import { z } from 'zod'
import { LocaleSchema } from '../localisation'
import { IataSchema, OpCoClassNameSchema } from './opCo'

export const PlatformTypeSchema = z.enum(['avios', 'whitelabel'])

export type PlatformType = z.infer<typeof PlatformTypeSchema>

export const PlatformThemeIdSchema = OpCoClassNameSchema.or(z.literal('avios'))

export type PlatformThemeId = z.infer<typeof PlatformThemeIdSchema>

export const PlatformConfigSchema = z.object({
  opCo: IataSchema,
  locale: LocaleSchema.default('en-GB'),
  market: z.string().default('GB'),
  theme: PlatformThemeIdSchema.default('avios'),
})

export type PlatformConfig = z.infer<typeof PlatformConfigSchema>
